/**
 * Enum definition for application types.
 */
export var TiMetricsApplication;
(function (TiMetricsApplication) {
    TiMetricsApplication["PF"] = "PF";
    TiMetricsApplication["TF"] = "TF";
})(TiMetricsApplication || (TiMetricsApplication = {}));
/**
 * Enum for data status types.
 *
 * @see TiMetricsDataStatus
 */
export var TiMetricsDataStatus;
(function (TiMetricsDataStatus) {
    TiMetricsDataStatus["ERROR"] = "ERROR";
    TiMetricsDataStatus["LOADING"] = "LOADING";
    TiMetricsDataStatus["NONE"] = "NONE";
    TiMetricsDataStatus["READY"] = "READY";
})(TiMetricsDataStatus || (TiMetricsDataStatus = {}));
/**
 * The `@TiMetricsTracker` decorator.
 * When applied, the component is tracked using `MetricsTracker` at
 * the end of the componentDidLoad lifecycle method.
 */
export function TiMetricsTracker() {
    return (target, _propertyKey) => {
        const { componentDidLoad } = target;
        // hijack the componentDidLoad  to track the component
        target.componentDidLoad = function () {
            // call the original componentDidLoad
            if (componentDidLoad) {
                componentDidLoad.call(this);
            }
            // add to tacking queue
            TiMetricsTracking.track(this);
        };
    };
}
/**
 * Metrics tracking utility.
 * Used by `@TiMetricsTracker` decorator and applied in trackable components.
 *
 * Usage:
 *
 *  `@TiMetricsTracker()`
 *  `@Element() hostElement: HTMLTi<ComponentName>Element`
 *
 * The public interface for this class is entirely static and just
 * the single method track(). Internally, a singleton instance is
 * used to hold a reference to a global queue array, where trackable
 * elements are pushed when loaded. This avoids multiple access
 * checks for the existence of the global queue, possibly eliminating
 * any race condition problems.
 *
 * @see TiMetricsTrackable
 */
class TiMetricsTracking {
    /**
     * Singleton constructor finds or creates the global queue only once.
     */
    constructor() {
        if (!window.com) {
            window.com = {};
        }
        const com = window.com;
        if (!com.TI) {
            com.TI = {};
        }
        if (!com.TI.webComponentQueue) {
            com.TI.webComponentQueue = {};
        }
        this.queue = com.TI.webComponentQueue;
    }
    /**
     * 'Track' the component by pushing the loaded component
     * to the global tracking queue.
     */
    static track(component) {
        TiMetricsTracking.getInstance().pushToQueue(component);
    }
    static getInstance() {
        if (!TiMetricsTracking.instance) {
            TiMetricsTracking.instance = new TiMetricsTracking();
        }
        return TiMetricsTracking.instance;
    }
    /**
     * Singleton push to global queue.
     */
    pushToQueue(component) {
        const componentName = component.hostElement.tagName;
        if (!this.queue[componentName]) {
            this.queue[componentName] = [];
        }
        this.queue[componentName].push(component);
    }
}
